import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogosComponent } from './catalogos.component';
import {CatalogosRouting} from "./catalogos-routing";
import {SharedModule} from "../../shared/shared.module";
import { FormpadreComponent } from './formpadre/formpadre.component';
import { DatosCatalogoComponent } from './datos-catalogo/datos-catalogo.component';
import { FormhijoComponent } from './formhijo/formhijo.component';
import { ProductoComponent } from './producto/producto.component';
import { ClienteComponent } from './cliente/cliente.component';
import { NuevoClienteComponent } from './cliente/nuevo-cliente/nuevo-cliente.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { ProductoAddComponent } from 'app/utilerias/producto-add/producto-add.component';
import { ProductoCargaMasivaComponent } from './producto/producto-carga-masiva/producto-carga-masiva.component'
import { CargaMasivaComponent } from 'app/utilerias/carga-masiva/carga-masiva.component';
import { NgxMaskModule } from 'ngx-mask';
// import { GrupoActivosComponent } from './cat-activos/grupo-activos/grupo-activos.component';
// import { ZonaGeograficaComponent } from './cat-geografico/zona-geografica/zona-geografica.component';
@NgModule({
  declarations: [
    CatalogosComponent,
    FormpadreComponent,
    DatosCatalogoComponent,
    FormhijoComponent,
    ProductoComponent,
    ClienteComponent,
    NuevoClienteComponent,
    ProductoAddComponent,
    ProductoCargaMasivaComponent,
    // CurrencyMaskModule
    // GrupoActivosComponent,
    // ZonaGeograficaComponent,
    CargaMasivaComponent
  ],
  imports: [
    CommonModule,
      CatalogosRouting,
      SharedModule,
      CurrencyMaskModule,
      NgxMaskModule.forRoot()
  ],
    // entryComponents: [
    //     FormpadreComponent,
    //     FormhijoComponent
    // ],
})
export class CatalogosModule { }